import React from "react";
import { Certificates } from "./Certificates";

const CompanyCard = ({
  companyDetail,
  checkWebsite,
  toggleMoreInfo,
  togglePopup,
  getCertificates,
  visible,
}) => {
  const keyLoc = "Loc.";
  const renderContent = visible;

  return (
    <div className="result">
      <div className="add-to-mail">
        <a href="#" data-remove-if-empty="ignore" />
      </div>
      <div className="company-detail">
        <div className="details">
          <h3>{companyDetail.relevantScore} - {companyDetail.Name}</h3>
          {companyDetail.AltName && companyDetail.AltName.length > 0 && (
            <>
              <span className="alternative-names">
                ({companyDetail.AltName})
              </span>
            </>
          )}

          {checkWebsite(companyDetail).length > 0 && (
            <div className="website">
              <a
                href={checkWebsite(companyDetail)}
                target="_blank"
                rel="noreferrer"
              >
                {companyDetail.Site || companyDetail.url_1}
              </a>
            </div>
          )}
          {companyDetail.Mail.length > 0 && (
            <div className="mail">
              <a
                href={`mailto:${companyDetail.Mail}`}
                target="_blank"
                rel="noreferrer"
              >
                {companyDetail.Mail}
              </a>
            </div>
          )}
          {companyDetail.Phone.length > 0 && (
            <div className="telephone">
              <a
                href={`tel:${companyDetail.Phone}`}
                target="_blank"
                rel="noreferrer"
              >
                {companyDetail.Phone}
              </a>
            </div>
          )}
          {companyDetail[keyLoc].length > 0 && (
            <div className="address">
              <a
                href={`https://www.google.nl/maps/place/${companyDetail[keyLoc]}`}
                target="_blank"
                rel="noreferrer"
              >
                {companyDetail[keyLoc]}
              </a>
            </div>
          )}
          {companyDetail.Rate !== null && (
            <div className="mobile-rating">
              {companyDetail.Rate !== null &&
                companyDetail.RateUrl !== null &&
                companyDetail.RateUrl.length > 0 &&
                companyDetail.Rate.length > 0 && (
                  <a
                    href={companyDetail.RateUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {companyDetail.Rate} via Klanten vertellen
                  </a>
                )}
            </div>
          )}
          {companyDetail.RateUrl !== null &&
            (companyDetail.Rate === null || companyDetail.Rate === "") && (
              <div className="mobile-rating">
                <a
                  href={companyDetail.RateUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  Beoordeel zelf
                </a>
              </div>
            )}
        </div>

        <div
          className="certificates"
          onClick={(e) =>
            togglePopup(getCertificates(companyDetail.Kwaliteitreg))
          }
        >
          <h4>Certificering</h4>
          <Certificates
            certificates={getCertificates(companyDetail.Kwaliteitreg)}
          />
        </div>
      </div>
      <div className="rating">
        <div className="number">
          {companyDetail.Rate === null
            ? "-"
            : companyDetail.Rate.length > 0
            ? companyDetail.Rate
            : "-"}
        </div>
        <div className="number-detail">
          {companyDetail.Rate !== null &&
            companyDetail.RateUrl !== null &&
            companyDetail.RateUrl.length > 0 &&
            companyDetail.Rate.length > 0 && (
              <strong>
                <a
                  href={companyDetail.RateUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  via Klanten vertellen
                </a>
              </strong>
            )}
          {companyDetail.RateUrl !== null &&
            (companyDetail.Rate === null || companyDetail.Rate === "") && (
              <strong>
                <a
                  href={companyDetail.RateUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  Beoordeel zelf
                </a>
              </strong>
            )}
        </div>
      </div>
      <div className="mobile-btn-more-info" onClick={(e) => toggleMoreInfo(e)}>
        <span className="show-more">Toon meer</span>
        <span className="show-less">Toon minder</span>
      </div>
    </div>
  );
};

export { CompanyCard };

/*

        */
